import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";

import { AppointmentCardNew } from "../../shared-external/components/appointment-card-new";
import {
  SearchProjectsHeader,
  SearchProjectsHeaderContent,
  SearchProjectsHeaderTitle,
} from "../shared-internal/components/search-projects/search-projects-header";
import { SearchProjectsRefinements } from "../shared-internal/components/search-projects/search-projects-refinements";
import { SearchProjectsRefinementsMenu } from "../shared-internal/components/search-projects/search-projects-refinements-menu";
import { SearchProjectsRefinementsMenuTrigger } from "../shared-internal/components/search-projects/search-projects-refinements-menu-trigger";
import { SearchProjectsProvider } from "../shared-internal/state/search-projects.context";
import { CustomSearchBar } from "./components/custom-search-bar";
// import { CustomSortBy } from "./components/custom-sort-by";
import { FinishedProjectsContent } from "./components/finished-projects-content";
import { GuaranteeBlock } from "./components/guarantee-block";

export function SearchFinishedProjectsPage() {
  const { t } = useTranslation();

  return (
    <SearchProjectsProvider
      status="finished"
      refinements={[
        "instrument",
        "tax_exemption",
        "risk",
        "category",
        "maturity",
      ]}
    >
      <SearchProjectsHeader>
        <SearchProjectsHeaderContent>
          <SearchProjectsHeaderTitle>
            {t("search_projects_page.financed.header.title")}
          </SearchProjectsHeaderTitle>
          <div className="hidden items-center gap-4 md:flex">
            {/* <CustomSortBy /> */}
            <CustomSearchBar />
          </div>
        </SearchProjectsHeaderContent>
        <SearchProjectsHeaderContent>
          <SearchProjectsRefinementsMenuTrigger />
          <SearchProjectsRefinements className="hidden w-[70%] md:flex" />
        </SearchProjectsHeaderContent>
      </SearchProjectsHeader>

      <SearchProjectsRefinementsMenu>
        <div className="flex flex-col gap-y-4">
          <CustomSearchBar />
          {/* <CustomSortBy triggerProps={{ variant: "secondary" }} /> */}
        </div>
      </SearchProjectsRefinementsMenu>

      <main className="bg-black-400">
        <FinishedProjectsContent />
      </main>

      <div className="bg-black-800">
        <GuaranteeBlock className="container mx-auto w-full px-4" />
      </div>

      <div className="container mx-auto w-full">
        <AppointmentCardNew className="p-4 lg:p-16" />
      </div>
    </SearchProjectsProvider>
  );
}
